import React from "react";
import { useState, useEffect } from "react";
import {
  getDepartmentAssetList,
  getDepartmentAssetListExport,
} from "../../services/AssetService";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import { getAllDepartments } from "../../services/SettingServices";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
const DepartmentAsset = () => {
  const userRole = useSelector((state) => state.auth.user.role);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportloading, setExportLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setToatl] = useState(0);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [selectedDepartmet, setSelecetdDepartment] = useState(null);
  const [param, setParam] = useState({
    query: "",
    department: "",
    page: "1",
    page_size: "10",
  });
  const getAssetList = () => {
    const { department, ...queryParam } = param;
    setLoading(true);
    getDepartmentAssetList(userRole !== "HOD" ? param : queryParam)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setToatl(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getDepartment = () => {
    getAllDepartments()
      .then((res) => {
        const deptList = res?.data?.results || [];
        const options = deptList.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setDepartmentOption(options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (userRole !== "HOD") {
      getDepartment();
    }
  }, []);

  useEffect(() => {
    getAssetList();
  }, [param]);

  useEffect(() => {
    const newDepartment = selectedDepartmet?.value || "";
    if (param.department !== newDepartment) {
      setParam((prev) => ({ ...prev, department: newDepartment }));
    }
  }, [selectedDepartmet]);

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleExport = () => {
    setExportLoading(true);
    let exportParam = { ...param, export: true };

    if (userRole === "HOD") {
      const { department, ...rest } = param;
      exportParam = { ...rest, export: true };
    }
    getDepartmentAssetListExport(exportParam)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Department-Asset.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };

  return (
    <div className="card">
      <div className="px-4 py-3 d-flex justify-content-end gap-2 flex-column flex-md-row">
        <div className="flex-fill flex-md-grow-0">
          <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
        </div>

        <div className="d-flex flex-wrap gap-2">
          {userRole !== "HOD" && (
            <GlobalSearchableDropdown
              options={departmentOption}
              selected={selectedDepartmet}
              onSelect={setSelecetdDepartment}
              placeholder="Department"
            />
          )}

          {/* <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select Department"
              options={departmentOption}
              value={selectedDepartmet}
              onChange={setSelecetdDepartment}
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                menu: (base) => ({ ...base, zIndex: 99 }),
              }}
            /> */}
          <button
            className="btn btn-success d-flex align-items-center gap-1 align-self-center"
            style={{ padding: "0.4rem 0.6rem" }}
            onClick={handleExport}
            disabled={exportloading}
          >
            {exportloading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaDownload />
            )}
            Export
          </button>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data?.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Asset Number</th>
                <th>Name</th>
                <th>Brand</th>
                <th>Cost (₹)</th>
                <th>Allocate By</th>
                {userRole !== "HOD" && <th>Allocate To</th>}
                <th>Allocate Date</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((asset, index) => (
                <tr key={index}>
                  <td>
                    {" "}
                    <Link
                      to={`/asset/${asset?.asset}/basic-details`}
                      className="fw-bold text-primary"
                    >
                      {asset?.asset_data?.asset_number || "-"}
                    </Link>
                  </td>
                  <td>{asset?.asset_data?.name || "-"}</td>
                  <td>{asset?.asset_data?.brand || "-"}</td>
                  <td>{`₹${asset?.asset_data?.purchase_cost}` || "-"}</td>
                  <td>{asset.allocated_by?.name || "-"}</td>
                  {userRole !== "HOD" && (
                    <td>{asset?.allocated_to?.department || "-"}</td>
                  )}
                  <td>
                    {asset.allocated_at
                      ? format(asset?.allocated_at, "dd MMM yyy")
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">No data found</div>
      )}
      {!loading && data?.length > 0 && (
        <div className="p-4">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default DepartmentAsset;
